<template>
  <v-col align="center">
    <v-card width="1000">
      <v-card-title style="font-weight: bold; font-size: 1.60em; margin-bottom: 3px">
        Welcome to HawkSoft Marketplace!
      </v-card-title>
      <v-card-text>
        <v-row class="px-4">
          <div style="text-align: start; font-weight: bold">
            HawkSoft Marketplace showcases and lets you activate optional features, add-on products, and third-party integrations.
          </div>
        </v-row>
        <v-row class="pa-4">
          <div class="text-left">
            <ul>
              <li>Turn on HawkSoft Data Sync and other HawkSoft products</li>
              <li>Purchase add-on products like HawkSoft E-Signature</li>
              <li>Enable sharing data with API integration partners</li>
              <li>See special offers with service providers available to HawkSoft customers</li>
            </ul>
          </div>
        </v-row>
        <v-row class="px-4">
          <div class="text-center font-weight-bold">
            This is your first time using the HawkSoft Marketplace.
          </div>
          <div class="text-left">
            To protect your account, please register your work email address to use Marketplace. This must be done by your agency's primary HawkSoft contact (generally the agency principle or designated HawkSoft administrator). Click the Register Now button to start the process.
          </div>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row justify="center">
          <v-btn color="warning" @click="navigateToEmailPage()">Register Now</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'RegistrationStart',
  methods: {
    navigateToEmailPage () {
      this.$router.push('registration/email');
    }
  }
};

</script>
